module.exports = __webpack_public_path__ + "img/upload.0dc3294b.svg";